import { FooterProps } from '@/components/Footer'
import atImage from '@/images/footer/at.webp'
import facebookImage from '@/images/footer/facebook.webp'
import instagramImage from '@/images/footer/instagram.webp'
import linkedinImage from '@/images/footer/linkedin.webp'
import twitterImage from '@/images/footer/twitter.webp'
import wifiImage from '@/images/footer/wifi.webp'
import youtubeImage from '@/images/footer/youtube.webp'

export const socialMediaList = [
  {
    image: youtubeImage,
    link: 'https://www.youtube.com/@DeHaat/featured',
    alt: 'youtube',
  },
  {
    image: linkedinImage,
    link: 'https://www.linkedin.com/company/dehaat/',
    alt: 'linkedin',
  },
  {
    image: twitterImage,
    link: 'https://twitter.com/DeHaatTM?s=09',
    alt: 'twitter',
  },
  {
    image: facebookImage,
    link: 'https://www.facebook.com/DeHaatTM/',
    alt: 'facebook',
  },
  {
    image: instagramImage,
    link: 'https://www.instagram.com/dehaat/?hl=en',
    alt: 'instagram',
  },
  {
    image: atImage,
    link: '',
    alt: 'at',
  },
  {
    image: wifiImage,
    link: '',
    alt: 'wifi',
  },
]

export const agcFooterLinks: FooterProps[] = [
  {
    heading: 'Organisation',
    content: [
      {
        label: 'About AgriCentral',
        link: 'https://www.globalagricentral.com/home',
      },
      {
        label: 'About Dehaat',
        link: 'https://agrevolution.in',
      },
    ],
  },
  {
    heading: 'Legals',
    content: [
      {
        label: 'Privacy Policy',
        link: 'https://policies.agrevolution.in/privacy-policy/',
      },
      {
        label: 'Terms & Conditions',
        link: 'https://policies.agrevolution.in/terms-and-conditions/',
      },
      {
        label: 'Responsible Disclosure',
        link: 'https://agrevolution.in/responsible-disclosure/',
      },
    ],
  },
]

export const footerLinks: FooterProps[] = [
  {
    heading: 'Quick Links',
    content: [
      {
        label: 'Crop Guide',
        link: 'https://dehaat.in/en/crop?redirect_uri=/crop-guide',
      },
      {
        label: 'Crop Doctor',
        link: 'https://dehaat.in/en/ask-question',
      },
      {
        label: 'Animal Doctor',
        link: 'https://bot.agrevolution.in/cattle-video-call-mweb',
      },
      {
        label: 'Farm Talk',
        link: 'https://dehaat.in/en?tab=1',
      },
      {
        label: 'Farm Monitoring',
        link: 'https://dehaat.in/en/prakshep',
      },
    ],
  },
  // {
  //   heading: 'More Links',
  //   content: [
  //     {
  //       label: 'Know your soil',
  //       link: 'https://agrevolution.in/know-your-soil',
  //     },
  //     {
  //       label: 'Agri input',
  //       link: 'https://agrevolution.in/agri-input',
  //     },
  //     {
  //       label: 'Agri output',
  //       link: 'https://agrevolution.in/agri-output-Harvest-and-Market-Access/',
  //     },
  //     {
  //       label: 'Growth and Health',
  //       link: 'https://agrevolution.in/health-growth-yield-prediction',
  //     },
  //     {
  //       label: 'Advisory',
  //       link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
  //     },
  //     {
  //       label: 'Agri Financing',
  //       link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
  //     },
  //   ],
  // },
  // {
  //   heading: 'Dehaat Services',
  //   content: [
  //     {
  //       label: 'Online shop',
  //       link: `?tab=2`,
  //       isInternal: true,
  //     },
  //     {
  //       label: 'Soil test',
  //       link: 'https://doxy.me/manishyadav',
  //     },
  //     {
  //       label: 'Crop doctor',
  //       link: '',
  //     },
  //     {
  //       label: 'Pashu Doctor',
  //       link: '',
  //     },
  //     {
  //       label: 'Farm Monitoring',
  //       link: '/prakshep',
  //       isInternal: true,
  //     },
  //     {
  //       label: 'Weather',
  //       link: '',
  //     },
  //     {
  //       label: 'Insurance',
  //       link: '/insurance',
  //       isInternal: true,
  //     },
  //     {
  //       label: 'Farmer Credit',
  //       link: '',
  //     },
  //     {
  //       label: 'Agri Videos',
  //       link: '',
  //     },
  //   ],
  // },
  {
    heading: 'Organisation',
    content: [
      {
        label: 'Corporate Website',
        link: 'https://agrevolution.in/',
      },
      {
        label: 'About Dehaat',
        link: 'https://agrevolution.in/company',
      },
      {
        label: 'Careers at Dehaat',
        link: 'https://agrevolution.in/careers',
      },
      {
        label: 'Authors And Experts',
        link: '',
      },
      {
        label: 'Contact Us',
        link: 'https://agrevolution.in/contact-us',
      },
      {
        label: 'Privacy Policy',
        link: 'https://policies.agrevolution.in/privacy-policy/',
      },
      {
        label: 'Return Policy',
        link: '',
      },
      {
        label: 'Terms and Conditions',
        link: 'https://policies.agrevolution.in/terms-and-conditions/',
      },
      {
        label: 'Responsible Disclosure',
        link: 'https://agrevolution.in/responsible-disclosure/',
      },
    ],
  },
]

export const productLinks = [
  {
    heading: 'Purchase according to category',
    content: [
      {
        title: 'Fungicide',
        description:
          'Antracol is a high-quality fungicide that protects crops from diseases like blight, grey leaf spots, etc. It also increases the greening effect of crops by solving the problem of zinc deficiency in crops. The effect of this fungicide lasts on the crops for 6-8 days.',
        link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
      },
      {
        title: 'Fungicide',
        description:
          'Antracol is a high-quality fungicide that protects crops from diseases like blight, grey leaf spots, etc. It also increases the greening effect of crops by solving the problem of zinc deficiency in crops. The effect of this fungicide lasts on the crops for 6-8 days.',
        link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
      },
      {
        title: 'Fungicide',
        description:
          'Antracol is a high-quality fungicide that protects crops from diseases like blight, grey leaf spots, etc. It also increases the greening effect of crops by solving the problem of zinc deficiency in crops. The effect of this fungicide lasts on the crops for 6-8 days.',
        link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
      },
      {
        title: 'Fungicide',
        description:
          'Antracol is a high-quality fungicide that protects crops from diseases like blight, grey leaf spots, etc. It also increases the greening effect of crops by solving the problem of zinc deficiency in crops. The effect of this fungicide lasts on the crops for 6-8 days.',
        link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
      },
      {
        title: 'Fungicide',
        description:
          'Antracol is a high-quality fungicide that protects crops from diseases like blight, grey leaf spots, etc. It also increases the greening effect of crops by solving the problem of zinc deficiency in crops. The effect of this fungicide lasts on the crops for 6-8 days.',
        link: 'https://agrevolution.in/Agricultural-Finance-Credit-Insurance',
      },
    ],
  },
  {
    heading: 'Purchase according to Crop',
    content: [
      {
        title: 'Green chilli',
        description:
          'rdh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan,',
        link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
      },
      {
        title: 'Green chilli',
        description:
          'rdh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan,',
        link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
      },
      {
        title: 'Green chilli',
        description:
          'rdh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan,',
        link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
      },
      {
        title: 'Green chilli',
        description:
          'rdh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan,',
        link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
      },
      {
        title: 'Green chilli',
        description:
          'rdh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan, Ardh galan,',
        link: 'https://agrevolution.in/advisory-farmers-helpline-and-support',
      },
    ],
  },
]

export const shopByContent = [
  {
    heading: 'Shop by Product Categories',
    items: [
      {
        label: 'Animal Nutrition',
        link: '/products/categories/Animal-Nutrition-5',
        isInternal: true,
      },
      {
        label: 'Crop Protection',
        link: '/products/categories/Crop-Protection-3',
        isInternal: true,
      },
      {
        label: 'Equipment',
        link: '/products/categories/Tools-and-Machinery-4',
        isInternal: true,
      },
      {
        label: 'Fertilisers',
        link: '/products/categories/Fertilisers-2',
        isInternal: true,
      },
      {
        label: 'Seeds',
        link: '/products/categories/Seeds-1',
        isInternal: true,
      },
    ],
  },
  {
    heading: 'Shop by Brands',
    items: [
      {
        label: 'ADAMA',
        link: '/products/brands/ADAMA-4',
        isInternal: true,
      },
      {
        label: 'ADVANTA',
        link: '/products/brands/ADVANTA-1',
        isInternal: true,
      },
      {
        label: 'ATUL',
        link: '/products/brands/ATUL-130',
        isInternal: true,
      },
      {
        label: 'BASF',
        link: '/products/brands/BASF-7',
        isInternal: true,
      },
      {
        label: 'BAYER',
        link: '/products/brands/BAYER-115',
        isInternal: true,
      },
      {
        label: 'FMC',
        link: '/products/brands/FMC-135',
        isInternal: true,
      },
      {
        label: 'GAPL',
        link: '/products/brands/GAPL-136',
        isInternal: true,
      },
      {
        label: 'IFFCO',
        link: '/products/brands/IFFCO-138',
        isInternal: true,
      },
      {
        label: 'SYNGENTA',
        link: '/products/brands/SYNGENTA-118',
        isInternal: true,
      },
      {
        label: 'UPL',
        link: '/products/brands/UPL-119',
        isInternal: true,
      },
    ],
  },
  {
    heading: 'Shop by Crops',
    sections: [
      {
        title: 'Cash Crops',
        items: [
          {
            label: 'Baby Corn',
            link: '/products/crops/Baby-Corn-186',
            isInternal: true,
          },
          {
            label: 'Cotton',
            link: '/products/crops/Cotton-129',
            isInternal: true,
          },
          { label: 'Jute', link: '/products/crops/Jute-41', isInternal: true },
          {
            label: 'Potato (Short Duration)',
            link: '/products/crops/Potato-(Short-Duration)-189',
            isInternal: true,
          },
          {
            label: 'Sugarcane',
            link: '/products/crops/Sugarcane-32',
            isInternal: true,
          },
          {
            label: 'Tobacco',
            link: '/products/crops/Tobacco-36',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Cereals',
        items: [
          {
            label: 'Barley',
            link: '/products/crops/Barley-127',
            isInternal: true,
          },
          {
            label: 'Maize',
            link: '/products/crops/Maize-106',
            isInternal: true,
          },
          {
            label: 'Paddy',
            link: '/products/crops/Paddy-22',
            isInternal: true,
          },
          {
            label: 'Paddy (Basmati)',
            link: '/products/crops/Paddy-(Basmati)-191',
            isInternal: true,
          },
          {
            label: 'Pearl Millet',
            link: '/products/crops/Pearl-Millet-180',
            isInternal: true,
          },
          {
            label: 'Rabi Maize',
            link: '/products/crops/Rabi-Maize-181',
            isInternal: true,
          },
          {
            label: 'Sorghum',
            link: '/products/crops/Sorghum-28',
            isInternal: true,
          },
          {
            label: 'Wheat',
            link: '/products/crops/Wheat-25',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Dry Fruits',
        items: [
          {
            label: 'Makhana',
            link: '/products/crops/Makhana-49',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Flowers',
        items: [
          {
            label: 'Carnation',
            link: '/products/crops/Carnation-128',
            isInternal: true,
          },
          {
            label: 'Marigold',
            link: '/products/crops/Marigold-146',
            isInternal: true,
          },
          { label: 'Rose', link: '/products/crops/Rose-183', isInternal: true },
          {
            label: 'Tuberose / Rajnigandha',
            link: '/products/crops/Tuberose-rajnigandha-141',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Fruits',
        items: [
          {
            label: 'Banana',
            link: '/products/crops/Banana-70',
            isInternal: true,
          },
          { label: 'Ber', link: '/products/crops/Ber-2', isInternal: true },
          {
            label: 'Chikoos',
            link: '/products/crops/Chikoos-111',
            isInternal: true,
          },
          {
            label: 'Custard apple',
            link: '/products/crops/Custard-apple-112',
            isInternal: true,
          },
          {
            label: 'Grapefruit',
            link: '/products/crops/Grapefruit-169',
            isInternal: true,
          },
          {
            label: 'Grapes',
            link: '/products/crops/Grapes-96',
            isInternal: true,
          },
          {
            label: 'Guava',
            link: '/products/crops/Guava-58',
            isInternal: true,
          },
          {
            label: 'Jack fruit',
            link: '/products/crops/Jack-fruit-125',
            isInternal: true,
          },
          {
            label: 'Kinnow',
            link: '/products/crops/Kinnow-187',
            isInternal: true,
          },
          {
            label: 'Lemon',
            link: '/products/crops/Lemon-61',
            isInternal: true,
          },
          {
            label: 'Litchi',
            link: '/products/crops/Litchi-59',
            isInternal: true,
          },
          {
            label: 'Mango',
            link: '/products/crops/Mango-63',
            isInternal: true,
          },
          {
            label: 'Muskmelon',
            link: '/products/crops/Muskmelon-90',
            isInternal: true,
          },
          {
            label: 'Orange',
            link: '/products/crops/Orange-101',
            isInternal: true,
          },
          {
            label: 'Papaya',
            link: '/products/crops/Papaya-20',
            isInternal: true,
          },
          {
            label: 'Pineapple',
            link: '/products/crops/Pineapple-50',
            isInternal: true,
          },
          {
            label: 'Pomegranate',
            link: '/products/crops/Pomegranate-72',
            isInternal: true,
          },
          {
            label: 'Strawberry',
            link: '/products/crops/Strawberry-100',
            isInternal: true,
          },
          {
            label: 'Watermelon',
            link: '/products/crops/Watermelon-51',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Medicinal',
        items: [
          { label: 'Amla', link: '/products/crops/Amla-162', isInternal: true },
          {
            label: 'Mentha',
            link: '/products/crops/Mentha-3',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Oilseeds',
        items: [
          {
            label: 'Castor',
            link: '/products/crops/Castor-166',
            isInternal: true,
          },
          {
            label: 'Groundnut',
            link: '/products/crops/Groundnut-159',
            isInternal: true,
          },
          {
            label: 'Mustard',
            link: '/products/crops/Mustard-4',
            isInternal: true,
          },
          {
            label: 'Sunflower',
            link: '/products/crops/Sunflower-33',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Pulses',
        items: [
          {
            label: 'Arhar / Tuar',
            link: '/products/crops/ArharTuar-10',
            isInternal: true,
          },
          {
            label: 'Beans',
            link: '/products/crops/Beans-11',
            isInternal: true,
          },
          {
            label: 'Bengal gram',
            link: '/products/crops/Bengal-gram-108',
            isInternal: true,
          },
          {
            label: 'Black gram',
            link: '/products/crops/Black-gram-185',
            isInternal: true,
          },
          {
            label: 'Chick Peas',
            link: '/products/crops/Chick-Peas-93',
            isInternal: true,
          },
          {
            label: 'Cluster Bean',
            link: '/products/crops/Cluster-Bean-170',
            isInternal: true,
          },
          {
            label: 'Cowpea',
            link: '/products/crops/CowPea-55',
            isInternal: true,
          },
          {
            label: 'French bean',
            link: '/products/crops/French-bean-115',
            isInternal: true,
          },
          {
            label: 'Green gram',
            link: '/products/crops/Green-gram-37',
            isInternal: true,
          },
          {
            label: 'Green Peas',
            link: '/products/crops/Green-Peas-53',
            isInternal: true,
          },
          {
            label: 'Lentil',
            link: '/products/crops/Lentil-38',
            isInternal: true,
          },
          {
            label: 'Linseed',
            link: '/products/crops/Linseed-107',
            isInternal: true,
          },
          {
            label: 'Pigeonpea',
            link: '/products/crops/Pigeonpea-184',
            isInternal: true,
          },
          {
            label: 'Soybean',
            link: '/products/crops/Soybean-23',
            isInternal: true,
          },
        ],
      },
      {
        title: 'Vegetables',
        items: [
          {
            label: 'Arbi (Colocasia)',
            link: '/products/crops/Arbi-(colacasia)-149',
            isInternal: true,
          },
          {
            label: 'Beetroot',
            link: '/products/crops/Beetroot-12',
            isInternal: true,
          },
          {
            label: 'Bitter gourd',
            link: '/products/crops/Bittergourd-21',
            isInternal: true,
          },
          {
            label: 'Bottle gourd',
            link: '/products/crops/Bottlegourd-24',
            isInternal: true,
          },
          {
            label: 'Brinjal',
            link: '/products/crops/Brinjal-13',
            isInternal: true,
          },
          {
            label: 'Broccoli',
            link: '/products/crops/Broccoli-109',
            isInternal: true,
          },
          {
            label: 'Cabbage',
            link: '/products/crops/Cabbage-40',
            isInternal: true,
          },
          {
            label: 'Carrot',
            link: '/products/crops/Carrot-92',
            isInternal: true,
          },
          {
            label: 'Cauliflower',
            link: '/products/crops/Cauliflower-15',
            isInternal: true,
          },
          {
            label: 'Chilli',
            link: '/products/crops/Chilli-77',
            isInternal: true,
          },
          {
            label: 'Cucumber',
            link: '/products/crops/Cucumber-71',
            isInternal: true,
          },
          {
            label: 'Drumstick',
            link: '/products/crops/Drumstick-158',
            isInternal: true,
          },
          {
            label: 'Ivy gourd',
            link: '/products/crops/Ivy-gourd-60',
            isInternal: true,
          },
          { label: 'Okra', link: '/products/crops/Okra-8', isInternal: true },
          {
            label: 'Onion',
            link: '/products/crops/Onion-78',
            isInternal: true,
          },
          {
            label: 'Pointed gourd',
            link: '/products/crops/Pointed-Gourd-79',
            isInternal: true,
          },
          {
            label: 'Potato',
            link: '/products/crops/Potato-80',
            isInternal: true,
          },
          {
            label: 'Pumpkin',
            link: '/products/crops/Pumpkin-65',
            isInternal: true,
          },
          {
            label: 'Radish',
            link: '/products/crops/Radish-27',
            isInternal: true,
          },
          {
            label: 'Ridged gourd',
            link: '/products/crops/Ridged-gourd-67',
            isInternal: true,
          },
          {
            label: 'Snake gourd',
            link: '/products/crops/Snake-gourd-121',
            isInternal: true,
          },
          {
            label: 'Spinach',
            link: '/products/crops/Spinach-31',
            isInternal: true,
          },
          {
            label: 'Sponge gourd',
            link: '/products/crops/Sponge-Gourd-39',
            isInternal: true,
          },
          {
            label: 'Tomato',
            link: '/products/crops/Tomato-81',
            isInternal: true,
          },
        ],
      },
    ],
  },
]
